import { render, staticRenderFns } from "./VaultFolders.vue?vue&type=template&id=250a1df0&scoped=true&"
import script from "./VaultFolders.vue?vue&type=script&lang=js&"
export * from "./VaultFolders.vue?vue&type=script&lang=js&"
import style0 from "./VaultFolders.vue?vue&type=style&index=0&id=250a1df0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a1df0",
  null
  
)

export default component.exports